import { atom } from 'recoil'

// Which tab the Agent Activity modal shows; lifted to an atom so other
// surfaces (e.g. the per-section agent editor) can open it on History
export type AgentActivityTab = 'active' | 'history'

export const agentActivityTabAtom = atom<AgentActivityTab>({
    key: 'agentActivityTabAtom',
    default: 'active',
})
